// @core/stores/authn/AuthnOidcStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { authnApi } from '@core/api';
import type {
  CheckOIDCSessionRequest,
  CheckOIDCSessionResponse,
  EndOIDCSessionRequest,
  EndOIDCSessionResponse,
  GetJWKSResponse,
  GetOpenIDConfigurationResponse,
} from '@core/types/authn';

class AuthnOidcStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Check OIDC session status
   */
  async CheckOIDCSession(data: CheckOIDCSessionRequest): Promise<CheckOIDCSessionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.CheckOIDCSession(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * End OIDC session (logout)
   */
  async EndOIDCSession(data: EndOIDCSessionRequest): Promise<EndOIDCSessionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.EndOIDCSession(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get JSON Web Key Set
   */
  async GetJWKS(params?: { }): Promise<GetJWKSResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.GetJWKS(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get OpenID Connect discovery configuration
   */
  async GetOpenIDConfiguration(params?: { }): Promise<GetOpenIDConfigurationResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.GetOpenIDConfiguration(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const authnOidcStore = new AuthnOidcStore();
